import { render, staticRenderFns } from "./refund-block.vue?vue&type=template&id=ad8c4a1e&scoped=true&lang=pug&"
import script from "./refund-block.vue?vue&type=script&lang=js&"
export * from "./refund-block.vue?vue&type=script&lang=js&"
import style0 from "./refund-block.vue?vue&type=style&index=0&id=ad8c4a1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8c4a1e",
  null
  
)

export default component.exports